module.exports = __webpack_public_path__ + "files/timsit.812b5be7b4679187926e18695bc410d8.pdf";